module.exports = __webpack_public_path__ + "static/media/notepad_1.b4ace140.ico";